import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useEmployeeDiscountCode = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getDrawableDiscountCodes = async () => {
    return sendRequest({
      url: '/api/v1/discountCode/drawable',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  };

  const drawIndividualCode = async discountCodeId => {
    return sendRequest(
      {
        url: `/api/v1/discountCode/${discountCodeId}/draw`,
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
      },
      'Fehler beim Ziehen des Codes'
    );
  };

  const getMyDrawnCodes = async discountCodeId => {
    return sendRequest({
      url: `/api/v1/discountCode/${discountCodeId}/my-draws`,
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  };

  return {
    isLoading,
    error,
    getDrawableDiscountCodes,
    drawIndividualCode,
    getMyDrawnCodes,
  };
};

export default useEmployeeDiscountCode;
